import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import 'react-accessible-accordion/dist/fancy-example.css';
import ReactPaginate from "react-paginate";
import { connect, useDispatch } from "react-redux";
import Select from "react-select";
import { Col, Input, Row, Table } from "reactstrap";
import "../../../css/settings.scss";
import { logout } from "../../../store/actions/AuthActions";
import { api } from "../../../utils/api";
import { translate } from "../../../utils/translate";
import LoadingV3 from "../../components/Loading/LoadingV3";
import customSelectStyles from '../SelectStyle';
import { otpStatusList, shownItem } from "../../../utils/config";
import NotFound from "../Common/NotFound";

const { RangePicker } = DatePicker;

const tagUsageList = [
    { label: "register", value: "register" },
    { label: "withdraw", value: "withdraw" },
    { label: "change_password", value: 'change_password' },
    { label: "change_transaction_password", value: 'change_transaction_password' },
    { label: "forget_password", value: "forget_password" },
]

const OTCtag = (props) => {
    const dispatch = useDispatch();
    const [productPerpage, setProductPerPage] = useState(10)
    const [pageCount, setPageCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [tagType, setTagType] = useState('');
    const [pageNumber, setPageNumber] = useState(1);
    const [status, setStatus] = useState('');
    const [email, setEmail] = useState('');
    const [result, setResult] = useState([]);
    const [from, setFrom] = useState("");
    const [firstLoad, setFirstLoad] = useState(true);
    const [to, setTo] = useState("");

    const changePage = (event) => {
        setPageNumber(event.selected + 1);
        getList(event.selected + 1)
    }
    const timerRef = useRef(null);

    useEffect(() => {
        if(firstLoad){
            getList();
            setFirstLoad(false);
        }
    }, []);

    useEffect(() => {
        if (!firstLoad) {
            setPageNumber(1);
            getList(1);
        }
    }, [email, to, from, tagType, status, productPerpage]);


    const getList = (page = pageNumber) => {
        setLoading(true);
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            let url = api.get_otps + `?page=${page}&sort_by=date_added&order_by=DESC`;
            if (productPerpage) {
                url = url + `&limit=${productPerpage}`
            }
            if (tagType) {
                url = url + `&type=${tagType}`
            }
            if (email) {
                url = url + `&email=${email}`
            }
            if (status) {
                url = url + `&status=${status}`
            }
            if (from && to) {
                url = url + `&date_start=${from}&date_end=${to}`
            }
            fetch(url, {
                method: "GET",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "Accept-Language": props.lang.toLowerCase(),
                    "Authorization": "Bearer " + props.auth.auth.access_token
                }),
            })
                .then(response => response.json())
                .then(responseJson => {
                    setTimeout(() => {
                        setLoading(false);
                    }, 1000);
                    if (responseJson.status === 'success') {
                        setResult(responseJson.data.results);
                        var pageCount = Math.ceil(responseJson.data.total_results / productPerpage)
                        setPageCount(pageCount);
                    } else {
                        if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                            dispatch(logout(props.history, 'login'));
                        }
                        console.log('error', responseJson.message)
                    }
                }).catch(error => {
                    console.error("error", error);
                });
        }, 1000);
    }

    const handleTimeChange = (e) => {
        const formattedFromDate = e ? dayjs(e[0]).format("YYYY-MM-DD") : '';
        const formattedToDate = e ? dayjs(e[1]).format("YYYY-MM-DD") : '';
        setFrom(formattedFromDate);
        setTo(formattedToDate);
    }
    return (
        <>
            <div className='pb-5 wallet'>
                <Row className="mx-0 px-0 mt-3 mt-md-0">
                    <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                        <div className="whiteContainer px-md-4 py-md-4 p-2">
                            <div className="tableContainer">
                                <Row className="align-items-center mt-3">
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="groupLabel-input">
                                            <div className="input-group">
                                                <Input
                                                    type="text"
                                                    placeholder={translate(props.lang, "Enter Email")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    onChange={e => setEmail(e.target.value)}
                                                    value={email}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="input-group-select select-placeholder-center">
                                            <Select
                                                options={
                                                    tagUsageList.length > 0 ? tagUsageList.map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                }
                                                placeholder={translate(props.lang, "Tag Usage")}
                                                className="input-transparent w-100 text-capitalize"
                                                styles={customSelectStyles}
                                                isSearchable={false}
                                                name="tagType"
                                                isClearable
                                                value={tagUsageList.filter(item => item.value === tagType).map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) }))}
                                                onChange={(e) => setTagType(e ? e.value : '')}
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <RangePicker
                                            className="w-100 input-transparent"
                                            placeholder={[
                                                translate(props.lang, "From"),
                                                translate(props.lang, "To"),
                                            ]}
                                            onChange={(e) => handleTimeChange(e)}
                                        />
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="input-group-select select-placeholder-center">
                                            <Select
                                                options={
                                                    otpStatusList.length > 0 ? otpStatusList.map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, "otp_" + item.label.toLowerCase()) })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                }
                                                placeholder={translate(props.lang, "Status")}
                                                className="input-transparent w-100 text-capitalize"
                                                styles={customSelectStyles}
                                                isSearchable={false}
                                                name="status"
                                                value={otpStatusList.filter(item => item.value === status).map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, "otp_" + item.label.toLowerCase()) }))}
                                                isClearable
                                                onChange={(e) => setStatus(e ? e.value : '')}
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="input-group-select select-placeholder-center">
                                            <Select
                                                options={
                                                    shownItem.length > 0 ? shownItem.map((item, i) => ({ key: i, value: item.value, label: item.label })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                }
                                                placeholder={translate(props.lang, "Result Per Page")}
                                                className="input-transparent w-100 text-capitalize"
                                                styles={customSelectStyles}
                                                isSearchable={false}
                                                value={productPerpage && shownItem.find(option => option.value === productPerpage)}
                                                name="productPerpage"
                                                onChange={(e) => setProductPerPage(e.value ? e.value : '')}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Table responsive className="w-100 table-list text-center position-relative">
                                    <thead>
                                        <tr>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Email")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Tag Usage")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Tag")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Used Date")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Status")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan={5}>
                                                    <LoadingV3 theme='light' />
                                                </td>
                                            </tr>
                                        ) : (
                                            result.length > 0 ? (
                                                result.map((item, i) => (
                                                    <tr role="row" key={i} className={`${i%2 === 0 ? 'even': 'odd'}`}>
                                                        <td className={`font-weight-500 font-16 text-center lh-base`}>{item.email}</td>
                                                        <td className={`font-weight-500 font-16 text-center text-capitalize`}>{translate(props.lang, item.type)}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.otp}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.date_added}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.status.toLowerCase()} </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr role="row" className={`even`}>
                                                    <td colSpan={5}>
                                                        <NotFound />
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                            <div className="pt-4">
                                {!loading && result.length > 0 ? (
                                    <div className="my-3">
                                        <ReactPaginate
                                            previousLabel={"<"}
                                            nextLabel={">"}
                                            pageCount={pageCount}
                                            forcePage={pageNumber - 1}
                                            onPageChange={changePage}
                                            containerClassName={"pagination font-weight-400 font-16 text-uppercase text-grey-2"}
                                            previousLinkClassName={"pagination__previouslink pagination-arrow"}
                                            nextLinkClassName={"pagination__nextlink pagination-arrow"}
                                            disabledClassName={"pagination__link--disabled text-muted"}
                                            activeClassName={"pagination__link--active text-black"}
                                            marginPagesDisplayed={window.innerWidth > 667 ? 3 : 1}
                                        />
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(OTCtag);